import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';
import injector from 'vue-inject';

import BusinessQualifications from '@/components/layout/partials/section/pages/BusinessQualifications';
import Calculator from '@/components/layout/partials/section/pages/Calculator';
import Codes from '@/components/layout/partials/section/pages/Codes';
import Commissions from '@/components/layout/partials/section/pages/Commissions';
import Dashboard from '@/components/layout/partials/section/pages/Dashboard';
import DashboardFirstTime from '@/components/layout/partials/section/pages/DashboardFirstTime';
import FNProductPacks from '@/components/layout/partials/section/pages/FNProductPacks';
import Futurocoin from '@/components/layout/partials/section/pages/Futurocoin';
import FuturocoinHistory from '@/components/layout/partials/section/pages/FuturocoinHistory';
import Login from '@/components/login/Login';
import Logout from '@/components/logout/Logout';
import MarketingPlan from '@/components/layout/partials/section/pages/MarketingPlan';
import MonthlyStatement from '@/components/layout/partials/section/pages/MonthlyStatement';
import MyTeam from '@/components/layout/partials/section/pages/MyTeam';
import News from '@/components/layout/partials/section/pages/News';
import Otp from '@/components/layout/partials/section/pages/Otp';
import Profile from '@/components/layout/partials/section/pages/Profile';
import ProfileEditData from '@/components/layout/partials/section/pages/ProfileEditData';
import Payout from '@/components/layout/partials/section/pages/Payout';
import PayoutHistory from '@/components/layout/partials/section/pages/PayoutHistory';
import Register from '@/components/register/Register';
import RemindPassword from '@/components/remind-password/RemindPassword';
import StartPacket from '@/components/layout/partials/section/pages/StartPacket';
import Invoices from '@/components/layout/partials/section/pages/Invoices';
import SponsorSystem from '@/components/layout/partials/section/pages/SponsorSystem';
import TermsAndConditions from '@/components/terms-and-conditions/TermsAndConditions';
import TermsUpdate from '@/components/terms/TermsUpdate';
import TopQualified from '@/components/layout/partials/section/pages/TopQualified';
import Withdraw from '@/components/layout/partials/section/pages/Withdraw';

Vue.use(Router);
Vue.use(injector);

/**
 * Inject services into components
 */
let api = injector.get('api'),
    popup = injector.get('popup'),
    user = injector.get('user');

const router = new Router({
    mode: 'history',
    routes: [
        /**
         * Main menu
         */
        {
            path: '/how-many-fto',
            name: 'Calculator',
            meta: {
                Auth: true,
                noPacket: true
            },
            component: Calculator
        },
        {
            path: '/business/commissions',
            name: 'BusinessCommissions',
            meta: {Auth: true},
            component: Commissions
        },
        {
            path: '/futurocoin',
            name: 'Futurocoin',
            meta: {
                Auth: true,
                noPacket: true
            },
            component: Futurocoin
        },
        {
            path: '/futurocoin/history',
            name: 'FuturocoinHistory',
            meta: {
                Auth: true,
                noPacket: true
            },
            component: FuturocoinHistory
        },
        {
            path: '/business/qualifications',
            name: 'BusinessQualifications',
            meta: {Auth: true},
            component: BusinessQualifications
        },
        {
            path: '/business/codes',
            name: 'Codes',
            meta: {Auth: true},
            component: Codes
        },
        {
            path: '/',
            name: 'Dashboard',
            meta: {Auth: true},
            component: Dashboard
        },
        {
            path: '/fnproductpacks',
            name: 'FNProductPacks',
            meta: {Auth: true},
            component: FNProductPacks
        },
        {
            path: '/login',
            name: 'Login',
            meta: {
                Auth: false,
                hideHeader: true,
            },
            component: Login,
            beforeEnter: (to, from, next) => {
                if (store.getters.checkAuth) {
                    next('/');
                } else {
                    Vue.http.get(api.auth.user).then((response) => {
                        user.fetchData(response.data, next);
                        next('/');
                    }).catch(() => {
                        next();
                    })
                }
                next();
            }
        },
        {
            path: '/logout',
            name: 'Logout',
            meta: {
                Auth: true,
                hideHeader: true,
                noPacket: true
            },
            component: Logout,
        },
        {
            path: '/marketing-plan',
            name: 'MarketingPlan',
            meta: {
                Auth: true,
                noPacket: true
            },
            component: MarketingPlan
        },
        {
            path: '/my-start-package',
            name: 'MyStartPacket',
            meta: {Auth: true},
            component: StartPacket
        },
        {
            path: '/business/commissions/monthly-statement',
            name: 'MonthlyStatement',
            meta: {Auth: true},
            component: MonthlyStatement
        },
        {
            path: '/my-start-package/invoices',
            name: 'Invoices',
            meta: {Auth: true},
            component: Invoices
        },
        {
            path: '/my-team',
            name: 'MyTeam',
            meta: {Auth: true},
            component: MyTeam
        },
        {
            path: '/news',
            name: 'News',
            meta: {Auth: true},
            component: News
        },
        {
            path: '/otp',
            name: 'Otp',
            meta: {
                Auth: true,
                OtpPage: true,
                noPacket: true
            },
            component: Otp,
            beforeEnter: (to, from, next) => {
                if (store.getters.user.showOtpPage) {
                    next();
                } else {
                    next({name: 'Profile'});
                }
            }
        },
        {
            path: '/payout',
            name: 'Payout',
            meta: {Auth: true},
            component: Payout
        },
        {
            path: '/payout/history',
            name: 'PayoutHistory',
            meta: {Auth: true},
            component: PayoutHistory
        },
        {
            path: '/payout-confirmation/:token/:id',
            name: 'PayoutConfirmation',
            beforeEnter: (to, from, next) => {
                if (to.params && to.params.token && to.params.id) {
                    Vue.http.post(api.payout.confirmByUser, {
                        'token': to.params.token,
                        'id': to.params.id
                    }).then(() => {
                        next({'name': 'PayoutHistory'});
                        popup.show('Payout was confirmed.')
                    }, (error) => {
                        popup.show(error.body.errors[0].message);
                        next({'name': 'PayoutHistory'});
                    });
                }
                next({'name': 'PayoutHistory'});
            }
        },
        {
            path: '/profile',
            name: 'Profile',
            meta: {
                Auth: true,
                noPacket: true
            },
            component: Profile
        },
        {
            path: '/profile/edit-data',
            name: 'ProfileEditData',
            meta: {
                Auth: true,
                noPacket: true
            },
            component: ProfileEditData
        },
        {
            path: '/register/:sponsor?',
            name: 'Register',
            meta: {
                Auth: false,
                hideHeader: true,
            },
            component: Register,
            beforeEnter: (to, from, next) => {
                if (store.getters.checkAuth) {
                    next('/');
                } else {
                    Vue.http.get(api.auth.user).then((response) => {
                        user.fetchData(response.data, next);
                        next('/');
                    }).catch(() => {
                        next();
                    });
                }
                next();
            }
        },
        {
            path: '/user/remind-password/:token',
            name: 'RemindPassword',
            meta: {
                Auth: false,
                hideHeader: true,
            },
            component: RemindPassword,
            beforeEnter: (to, from, next) => {
                if (store.getters.checkAuth) {
                    next('/');
                } else {
                    Vue.http.get(api.auth.user).then((response) => {
                        user.fetchData(response.data, next);
                        next('/');
                    }).catch(() => {
                        next();
                    })
                }
                next();
            }
        },
        {
            path: '/start-package',
            name: 'StartPacket',
            meta: {
                Auth: true,
                noPacket: true
            },
            component: DashboardFirstTime
        },
        {
            path: '/sponsor-system',
            name: 'SponsorSystem',
            meta: {Auth: true},
            component: SponsorSystem
        },
        {
            path: '/code/confirm/:code',
            name: 'CodeConfirmation',
            meta: {Auth: true},
            component: Codes
        },
        {
            path: '/terms',
            name: 'Terms',
            meta: {
                Auth: false,
                noPacket: true
            },
            component: TermsAndConditions
        },
        {
            path: '/terms-update',
            name: 'TermsUpdate',
            meta: {
                Auth: true,
                noPacket: true
            },
            component: TermsUpdate
        },
        {
            path: '/top-qualified',
            name: 'TopQualified',
            meta: {Auth: true},
            component: TopQualified
        },
        {
            path: '/withdraw',
            name: 'Withdraw',
            meta: {
                Auth: true,
                noPacket: true
            },
            component: Withdraw
        },
        /**
         * Errors
         */
        {
            path: "*",
            meta: {
                Auth: false,
                hideHeader: true,
                hideFooter: true,
            },
            beforeEnter: (to, from, next) => {
                store.commit('setError', {
                    status: true,
                    code: 404,
                    redirect: true
                });
                next({name: 'Dashboard'});
            }
        }
    ]
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js